module.exports = __webpack_public_path__ + "static/media/NWIL-Booklet-A5-Nov 2022.83932124.pdf";